const sleep = async (milliseconds) => {
    await new Promise(resolve => {
        return setTimeout(resolve, milliseconds)
    });
};

const testSleep = async () => {
    console.log('Step 1 - Called');
    await sleep(2000);
    $('.related-products-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      mobileFirst: true, 
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: '20px',
      responsive: [
         {
            breakpoint: 749,
            settings: "unslick"
         }
      ]
    });
}

testSleep();
